<template>
    <v-container fluid>

        <div class="text-xs-center pt-2">
            <h3>Επικοινωνία με Γραφείο Αρωγής</h3>
            <hr/>
        </div>


        <v-layout row wrap justify-center class=" mt-2">
            <v-flex xl11 >
                <v-card>
                    <v-card-text>
                        <v-btn color="primary" @click="openNewIssueDialog">
                            Νέα ερώτηση
                        </v-btn>
                        <v-tooltip right color="primary">
                            <template slot="activator" slot-scope="{ on }">
                              <v-chip color="primary" v-on="on" @click="copyPhone">
                                <v-icon style="cursor: pointer" color="white">mdi-phone</v-icon>
                              </v-chip>
                            </template>
                            <span >Εναλλακτικά, μπορείτε να επικοινωνήσετε με το Γραφείο Αρωγής τηλεφωνικά στο 215 215 7850 </span>
                        </v-tooltip>
                        <v-data-table
                                :headers="headers"
                                :items="items"
                                :server-items-length="tableLength"
                                :pagination.sync="pagination"
                                item-key="id">

                            <template slot="items" slot-scope="props">

                                <td class="text-xs-center">{{ props.item.key }}</td>
                                <td class="text-xs-center">{{ props.item.fields.formattedCreationDate }}</td>
                                <td class="text-xs-center">{{ props.item.fields.issuetype.name }}</td>
                                <td class="text-xs-center">
                                    <v-chip style="border-width: 2px" outline :color="props.item.fields.status.name==='Open' || props.item.fields.status.name==='Reopened' ? '#42526E':'#20b2aa'">
                                        {{ props.item.fields.status.name }}
                                        <v-icon class="ml-1 mb-1" :color="props.item.fields.status.name==='Open' || props.item.fields.status.name==='Reopened' ? '#42526E':'#20b2aa'">
                                            {{props.item.fields.status.name==='Open' || props.item.fields.status.name==='Reopened' ? 'mdi-microscope':'mdi-check-all'}}
                                        </v-icon>
                                    </v-chip>
                                </td>

                                <td class="text-xs-center">

                                    <v-tooltip top>
                                        <template slot="activator" slot-scope="{ on }">
                                            <v-icon @click="openViewIssueDialog(props.item)" v-if="props.item.fields.customfield_12754 && props.item.fields.customfield_12754.trim().length > 0" v-on="on" color="primary">mdi-message-text</v-icon>
                                            <v-icon @click="openViewIssueDialog(props.item)" v-else v-on="on" color="gray">mdi-message-outline</v-icon>
                                        </template>
                                        <span>Προβολή δελτίου</span>
                                    </v-tooltip>
                                </td>

                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>

        <v-dialog @keydown.esc="viewIssueDialog = false" max-width="900px" persistent v-model="viewIssueDialog">
            <v-card>
                <v-card-title class="primary white--text">
                    <h4 class="white--text primary" >Στοιχεία δελτίου</h4>
                    <v-spacer></v-spacer>
                    <v-icon @click="closeDialogViewIssueDialog" color="white">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-textarea readonly
                            v-model="viewIssueText"
                            outlined rows="7"
                            label="Κείμενο ερώτησης"
                            no-resize>
                    </v-textarea>
                    <v-layout row wrap justify-center class=" mt-2" v-if="viewIssueReply && viewIssueReply.trim().length > 0">
                        <v-flex >
                            <v-card>
                                <v-card-text style="background-color: #07575b">
                                    <v-layout justify="start">
                                        <h3 class="ml-3 mt-2" style="color: white ">Απάντηση</h3>
                                    </v-layout>
                                    <v-layout justify="center">
                                        <v-flex >
                                            <v-card>
                                                <v-card-text style="background-color: #c8fff7">
                                                    <v-row justify="center">
                                                        <v-col cols="12">
                                                            <v-textarea
                                                                    outlined
                                                                    no-resize
                                                                    rows="5"
                                                                    readonly
                                                                    v-model="viewIssueReply">
                                                            </v-textarea>
                                                        </v-col>
                                                    </v-row>
                                                </v-card-text>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>

                                </v-card-text>
                            </v-card>
                        </v-flex>

                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>

        <NewIssueDialog :dialog-key="newIssueDialogKey" @refresh-issues="refreshIssues"/>
        <v-snackbar
                v-model="snackbar" top
                color="cyan darken-3"
                timeout="1500">
            Το τηλέφωνο αντιγράφηκε
            <v-icon color="white">mdi-check-all</v-icon>
        </v-snackbar>
    </v-container>
</template>

<script>
	import NewIssueDialog from "./NewIssueDialog";
	import requests from "../../requests";
  import util from "@/utilities";
	export default {
		name: "Issues",
		components: {NewIssueDialog},
		data: () => ({
			headers: [
				{text: 'Αναγνωριστικό', align: 'center', sortable: false, value: 'key'},
				{text: 'Ημ/νία Αποστολής', align: 'center', sortable: true, value: 'fields.creationDateTimestamp'},
				{text: 'Είδος', align: 'center', sortable: false, value: 'fields.issuetype.name'},
				{text: 'Κατάσταση', align: 'center', sortable: false, value: 'fields.status.name '},
				{text: 'Απάντηση', align: 'end', sortable: false, value: ''},
			],
            pagination: {
              sortBy: 'fields.creationDateTimestamp',
              descending: true,
            },
			alert: true,
            newIssueDialogKey:0,
			items: [],
			tableLength: 0,
			newIssueDialog: false,
			viewIssueDialog: false,
			viewIssueText: '',
			viewIssueReply: '',
			snackbar:false,
		}),

        methods:{
			copyPhone(){
				navigator.clipboard.writeText('2152157850');
				this.snackbar = true;
            },

	        refreshIssues(data){
	        	this.items = data.issues;
            },

	        openViewIssueDialog(item) {
		        this.viewIssueText = item.fields.description;
		        this.viewIssueReply = item.fields.customfield_12754;
		        this.viewIssueDialog = true;
	        },

	        openNewIssueDialog(){
	        	this.newIssueDialogKey++;
		        this.$store.commit('setNewIssueDialog', true);
            },

	        closeDialogViewIssueDialog(){
		        this.viewIssueDialog = false;
            },
        },

        created() {
	        this.$store.commit('setLoadingModal', true);
			requests.get('student/api/student/tickets', (resp) =>{
				this.$store.commit('setLoadingModal', false);
				this.items = resp.issues;
            })
        },

    mounted() {
      util.removeDatatableLoadingElement();
    }
  }
</script>

<style scoped>

</style>